import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Card, CardContent } from '@material-ui/core';
import { AttachFile as AttachFileIcon } from '@material-ui/icons';

// import { InputAcceptType } from '../../../common/api/File.interface';
import { Attachment } from '../../../common/attachment/Attachment.interface';
import CardTitle from '../../../common/card/CardTitle';
import InputFile from '../../../common/forms/InputFile';
import { useTaskEntityFields } from '../../workflow/Workflow.hooks';
import { useUpdateTask } from '../Task.hooks';
import { BaseTaskCardProps } from '../Task.interface';

const StyledInputFile = styled(InputFile)`
  .drag-empty-container {
    margin: 8px 16px 16px;
  }
  .input-file-table {
    border: unset;
    border-radius: unset;
  }
`;

export interface TaskAttachmentCardProps extends BaseTaskCardProps {
  title?: string;
  compact?: boolean;
  disabled?: boolean;
  attachments?: Attachment[]; // attachment override
}

const TaskAttachmentCard: React.FC<TaskAttachmentCardProps> = (
  props: TaskAttachmentCardProps
) => {
  const {
    task,
    title = 'Attachments',
    compact = false,
    disabled = false,
    attachments,
    onChange,
    onError
  } = props;
  const { updatedTask, isUpdating, updateError, updateTask } = useUpdateTask(
    task.id || 0
  );
  const { isFieldDisabled } = useTaskEntityFields(task);

  useEffect(() => {
    if (updatedTask) {
      onChange?.(updatedTask);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedTask]);

  useEffect(() => {
    if (updateError) {
      onError?.(updateError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateError]);

  return (
    <Card>
      <CardTitle>
        <AttachFileIcon />
        {title}
      </CardTitle>
      <CardContent style={{ padding: 0 }}>
        <StyledInputFile
          multiple
          compact={compact}
          isLoading={isUpdating}
          uploadPath='attachments'
          values={attachments || task.attachments || []}
          disabled={disabled || isFieldDisabled('attachment')}
          // Accept all file types
          // inputType={InputAcceptType.Documents}
          onChange={attachments => updateTask({ attachments })}
        />
      </CardContent>
    </Card>
  );
};

export default TaskAttachmentCard;
